import { createAsyncThunk } from '@reduxjs/toolkit';
import apiInstanceV2 from '../../Apis/AxiosV2';
import axios from "axios";
import {URL} from "../../Apis/Constants";
import {errorMsg} from "../../Apis/functions";
import apiInstance from "../../Apis/Axios";

/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const serviceName = 'request-access-service';
export const CreateRequestAccess = createAsyncThunk('request/CreateRequestAccess', async (params, { dispatch, getState }) => {
    const response = await apiInstanceV2
        .post(`${serviceName}/v1/create`, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});

export const GetRequestAccessById = createAsyncThunk(
    'requestAccess/getRequestAccessById',
    async (id, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`${serviceName}/v1/get-by-id/${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const GetRequestAccessAssets = createAsyncThunk(
    'requestAccess/getRequestsAccessAssets',
    async (param, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .get(`${serviceName}/v1/request-access-asset/${param}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const ApplyDecisionRequest = createAsyncThunk(
    'requestAccess/applyDecisionRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(`${serviceName}/v1/apply-decision`, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

export const AssignEmployeeRequest = createAsyncThunk(
    'requestAccess/assignEmployeeRequest',
    async (params, { dispatch, getState }) => {
        const result = await apiInstanceV2
            .put(`${serviceName}/v1/assign-employee`, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);



export const PublicCreateRequest = createAsyncThunk('request/publicCreateRequest', async (params, { dispatch, getState }) => {
    try {
        return await axios.post(`${URL}${serviceName}/v1/public/create`, params);
    } catch (error) {
        if (!error.response) {
            errorMsg(error.response.status)
        }
        return { data: error.response.data, status: error.response.status };
    }
});

export const PublicCreateRequestDocument = createAsyncThunk('request/CreateRequestDocument', async (params, { dispatch, getState }) => {
    try {
        return await axios.post(`${URL}${serviceName}/v1/public/request-access-asset/create`, params, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
    } catch (error) {
        if (!error.response) {
            errorMsg(error.response.status)
        }
        return { data: error.response.data, status: error.response.status };
    }
});

export const RequestAccessMarkFilesAsRead = createAsyncThunk('request/markFilesAsRead', async (body) => {
    const response = await apiInstance
        .post('request-access-service/v1/notifications/mark-as-read', body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});
